export enum OrganizationType {
  CARRIER = "Carrier",
  DEALER = "Dealer",
  DISTRIBUTION_CENTER = "Distribution Center",
  FREIGHTVERIFY = "FreightVerify",
  HEALTHCAREPROVIDER = "Healthcare Provider",
  PARTNER = "Partner",
  SHIPPER = "Shipper",
  SUPPLIER = "Supplier",
  THIRDPARTY = "ThirdParty",
}

export enum MapType {
  HERE = "Here",
  GOOGLE = "Google",
}

export type Organization = {
  organization_id: number;
  org_name: string;
  org_type: OrganizationType;
  fv_id: string;
  map_type: MapType;
};

export enum MapPreference {
  SHIPMENT_COORDINATES = "SHIPMENT_COORDINATES",
  MILESTONES = "MILESTONES",
  ORIGIN_AND_DESTINATION = "ORIGIN_AND_DESTINATION",
  CONNECTED_CAR = "CONNECTED_CAR",
}

/**
 * @enableCheckbox - set to true/false based on availability of co-ordinates data
 * @showCoordinatesOnMap - when checkbox is clicked, display co-ordinates on map
 * @display - show/hide option in the Map Options panel
 * CONNECTED_CAR - display option is based on
 * DISPLAY_CONNECTED_CAR_SOURE and DISPLAY_CONNECTED_CAR_TAB system_config
 */
export const MAP_OPTIONS = {
  [MapPreference.SHIPMENT_COORDINATES]: {
    enableCheckbox: false,
    showCoordinatesOnMap: true,
    title: "Shipment Coordinates",
    display: true,
  },
  [MapPreference.CONNECTED_CAR]: {
    enableCheckbox: false,
    showCoordinatesOnMap: true,
    title: "Connected Car",
    display: true,
  },
  [MapPreference.MILESTONES]: {
    enableCheckbox: false,
    showCoordinatesOnMap: true,
    title: "Milestones",
    display: true,
  },
  [MapPreference.ORIGIN_AND_DESTINATION]: {
    enableCheckbox: false,
    showCoordinatesOnMap: true,
    title: "Origin & Destination",
    display: true,
  },
};
